// extracted by mini-css-extract-plugin
export var partners = "index-module--partners--sWE3e";
export var partnersContainer = "index-module--partnersContainer--Cl3GC";
export var partnersTitle = "index-module--partnersTitle--AC8BH";
export var partnersWrap = "index-module--partnersWrap--sPiBp";
export var gradientLine = "index-module--gradientLine--6wuho";
export var tickerWrap = "index-module--tickerWrap--yXvFD";
export var sponsorImage = "index-module--sponsorImage--a+66I";